import { Circle, Loader2, AlertCircle, Disc } from 'lucide-react';
import classes from '../ControlBar/ControlBar.module.css';

interface RecordingButtonProps {
  status: 'IDLE' | 'IN_PROGRESS' | 'LOADING' | 'FAILED';
  onStartRecording: () => void;
  onStopRecording?: () => void;
}

export const RecordingButton = ({ status, onStartRecording }: RecordingButtonProps) => {
  const getButtonContent = () => {
    switch (status) {
      case 'IDLE':
        return {
          icon: <Circle size={20} />,
          text: 'Record',
          disabled: false,
          onClick: onStartRecording,
        };
      case 'LOADING':
        return {
          icon: <Loader2 size={20} className={classes.loadingIcon} />,
          text: 'Loading',
          disabled: true,
          onClick: () => {},
        };
      case 'IN_PROGRESS':
        return {
          icon: <Disc size={20} className={classes.activeIcon} />,
          text: 'REC',
          disabled: true, // @ToDo: Need to implement stop recording functionality
          onClick: () => {},
        };
      case 'FAILED':
        return {
          icon: <AlertCircle size={20} />,
          text: 'Failed',
          disabled: false,
          onClick: onStartRecording,
        };
    }
  };

  const { icon, text, disabled, onClick } = getButtonContent();

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-status={status}
      className={`lk-button ${classes.button}`}
    >
      {icon}
      <span>{text}</span>
    </button>
  );
};
